var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payments-control-btn"},[_c('taskbar-button',{attrs:{"icon":"md-filing","size":"24","show-badge":_vm.isNew,"badge-type":"error","click-handler":_vm.openPaymentControlModal,"tooltip-content":"Распределение платежей из 1С"}}),_c('payment-control')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }